import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { useCreateTitle } from "@coworker/apprestructured/src/task-management/services/useCreateTitle";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { useTranslation } from "@coworker/locales";
import styles from "./BannerTitleAndFieldCardFragment.module.css";

export type BannerTitleAndFieldCardFragmentConfigProps = {
  field: string;
  translationKey: string;
};

type BannerTitleAndFieldCardFragmentProps = {
  configProps: BannerTitleAndFieldCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function BannerTitleAndFieldCardFragment({
  configProps,
  commonProps,
}: BannerTitleAndFieldCardFragmentProps) {
  const { field, translationKey } = configProps;
  const { task } = commonProps;
  const { t } = useTranslation();

  const title = useCreateTitle(task);

  const arrayField = getByPath(task, field);

  if (isLoading(task) || isLoading(title)) {
    return <LoadingCardFragment />;
  }

  if (!title || !Array.isArray(arrayField) || arrayField.length === 0) {
    return null;
  }

  const count = arrayField.length;

  return (
    <FixaText textStyle="Body.M" className={styles["root"]}>
      {title} {t(translationKey, { count })}
    </FixaText>
  );
}

export default BannerTitleAndFieldCardFragment;
